<!--suppress ALL -->
<template>
  <detail-template :classCustom="['detail-docs']">
    <template #content>
      <i @click="goBack" class="back-icon border-radius fal fa-arrow-right"></i>
      <div class="header">
        <div class="docTags">
          <el-tag
            v-if="vbOutgoingDoc.docTypeName"
            size="medium"
            class="margin-right-5"
            >{{ vbOutgoingDoc.docTypeName }}
          </el-tag>

          <tdhvp-doc-priority-tag
            v-if="!!vbOutgoingDoc.priorityName"
            :priorityName="vbOutgoingDoc.priorityName"
            class="margin-right-5"
          >
          </tdhvp-doc-priority-tag>
        </div>

        <h4 class="title-name">{{ vbOutgoingDoc.quote }}</h4>

        <tdhvp-doc-download
          :docId="id"
          :docType="ATTACHMENT_OBJECT_TYPE.VB_DI"
          :userDeptRoleId="userDeptRoleId"
        ></tdhvp-doc-download>
      </div>

      <VuePerfectScrollbar class="scroll-area">
        <div class="body">
          <div class="group__info margin-top-10 padding-bottom-10">
            <div class="title font-size__medium">Thông tin</div>
            <div class="ctn">
              <div class="list-info width__100">
                <div
                  class="item flex-row flex__left margin-bottom-10"
                  v-if="vbOutgoingDoc.docCode"
                >
                  <div class="label font-size__small txt-right">
                    Số ký hiệu:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ vbOutgoingDoc.docCode || "-" }}
                  </div>
                </div>

                <div
                  class="item flex-row flex__left margin-bottom-10"
                  v-if="vbOutgoingDoc.docDate"
                >
                  <div class="label font-size__small txt-right">
                    Ngày văn bản:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{
                      vbOutgoingDoc.docDate
                        | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY"
                        })
                    }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Hạn xử lý:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{
                      vbOutgoingDoc.deadlineDate
                        | dateFormatter({
                          nullValue: "-",
                          dateFormat: "DD/MM/YYYY HH:mm"
                        })
                    }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Đơn vị ban hành:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ vbOutgoingDoc.publisherName || "-" }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Người ký duyệt:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ vbOutgoingDoc.signerName || "-" }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Đơn vị thực hiện:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ vbOutgoingDoc.editorDeptName || "-" }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Số trang/ Số bản:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ vbOutgoingDoc.numberOfPage || "-" }} /
                    {{ vbOutgoingDoc.numberOfCopy || "-" }}
                  </div>
                </div>

                <div
                  class="item flex-row flex__left margin-bottom-10"
                  v-if="docReceiverDepts && docReceiverDepts.length"
                >
                  <div class="label font-size__small txt-right">
                    Đơn vị nhận
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <span v-for="item in docReceiverDepts" :key="item.id">
                      {{ item.objectName || "-" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <tdhvp-doc-histories
              v-if="!!vbOutgoingDoc && !!vbOutgoingDoc.tdhvpHistory"
              :tdhvpHistory="vbOutgoingDoc.tdhvpHistory"
            ></tdhvp-doc-histories>
          </div>
        </div>
      </VuePerfectScrollbar>
    </template>
  </detail-template>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import constants from "../../../constants";
import dateFormatter from "../../../filters/dateFormatter";
import goBackMixin from "../../../mixins/goBackMixin";
import { vbOutgoingDocReceiversTdhvpService } from "../../../services/tdhvp/vbOutgoingDocReceiversTdhvpService";
import { vbOutgoingDocTdhvpViewService } from "../../../services/tdhvp/vbOutgoingDocTdhvpViewService";
import BreakWordSpan from "../../adminstration/ketluan/break-word-span";
import DetailTemplate from "../../common/detail";
import TdhvpDocDownload from "../common/tdhvp-doc-download";
import TdhvpDocHistories from "../common/tdhvp-doc-histories";
import TdhvpDocPriorityTag from "../common/tdhvp-doc-priority-tag";

export default {
  name: "tdhvp-doc-out-detail",
  components: {
    TdhvpDocDownload,
    TdhvpDocHistories,
    BreakWordSpan,
    TdhvpDocPriorityTag,
    DetailTemplate,
    VuePerfectScrollbar
  },

  mixins: [goBackMixin],
  filters: { dateFormatter },

  data() {
    return {
      vbOutgoingDoc: {},
      docReceiverDepts: null,
      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
    userDeptRoleId() {
      return this.$store.getters.userDeptRoleId;
    }
  },

  watch: {
    id() {
      this.initPage();
    }
  },

  async created() {
    await this.initPage();
  },

  methods: {
    async initPage() {
      await this.loadVbOutgoingDoc();
      await this.loadDocReceiverDepts();
    },

    loadVbOutgoingDoc() {
      return vbOutgoingDocTdhvpViewService
        .findById(this.id)
        .then(response => (this.vbOutgoingDoc = response.data));
    },

    loadDocReceiverDepts() {
      return vbOutgoingDocReceiversTdhvpService
        .findAllByDocIdAndObjectType(
          this.id,
          constants.RECEIVER_OBJECT_TYPE.DONVI
        )
        .then(response => (this.docReceiverDepts = response.data));
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/thdvp/doc-out/tdhvp-doc-out-detail.vue